import Head from "next/head"
import { useRouter } from "next/router"

import { fontFamily } from "../../../css/font"
import EstimateProvider from "../../../features/oneClickEstimate/EstimateProvider"
import OneClickEstimate from "../../../features/oneClickEstimate/pcb/OneClickEstimate"
import Fallback from "../../../features/oneClickEstimate/pcb/layout/Fallback"
import AnswerChan from "../../../layout/MyPage/Inquiry/answerChan/AnswerChan"
import * as Sentry from "../../../lib/Sentry"
import type { GetStaticProps, NextPageWithLayout } from "../../../types/next"

import ogpImage from "../../../features/oneClickEstimate/pcb/img/1-ClickOGPImage.png"

const OneClickEstimatePage: NextPageWithLayout = () => {
  const { basePath } = useRouter()

  return (
    <>
      <Head>
        <link rel="preload" as="font" type="font/woff2" href={`${basePath}/fonts/roboto/roboto-v50-latin-regular.woff2`} crossOrigin="anonymous" />
        <link rel="preload" as="font" type="font/woff2" href={`${basePath}/fonts/roboto/roboto-v50-latin-500.woff2`} crossOrigin="anonymous" />
        <link rel="preload" as="font" type="font/woff2" href={`${basePath}/fonts/roboto/roboto-v50-latin-700.woff2`} crossOrigin="anonymous" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap"
          rel="stylesheet"
        />
      </Head>
      <Sentry.ErrorBoundary fallback={<Fallback />}>
        <OneClickEstimate />
        <AnswerChan />
      </Sentry.ErrorBoundary>
    </>
  )
}

export default OneClickEstimatePage

OneClickEstimatePage.getLayout = (page) => {
  return <EstimateProvider>{page}</EstimateProvider>
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      title: "1-Click見積:プリント基板をWEBでオンライン見積",
      font: fontFamily.Noto,
      seo: {
        description:
          "P板.comの1-Click見積は、プリント基板の設計・製造・部品実装をWEBでスピーディにお見積／ご発注いただけます。WEBでお見積りできない仕様でもご相談承ります。",
        canonical: "https://www.p-ban.com/kiban/com/csComEst.do",
        ogp: {
          url: "https://www.p-ban.com/kiban/com/csComEst.do",
          title: "P板.com 1-Click見積",
          image: ogpImage,
          description: "プリント基板業界初の見積りシステムで、瞬時に納期と費用を明朗回答",
        },
      },
    },
  }
}
